<template>
  <span v-if="isLoggedIn">
    <a :href="printingDataUrl"> {{ lang.download_printing_data }} </a>
  </span>
  <span v-else>
    <v-tooltip
      bottom
      color="grey lighten-2"
      v-model="isShowTootip"
      v-bind="{ disabled: !isShowTootip }"
    >
      <a slot="activator" @click.prevent="isShowTootip = !isShowTootip">
        {{ lang.download_printing_data }}
      </a>
      <span class="black--text">{{ lang.please_login }}。</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: "vc-share-download-printing-data",
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    printingDataUrl: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {
          download_printing_data: "印刷用データのダウンロード",
          please_login: "ログインしてください。"
        };
      }
    }
  },
  data: () => ({
    isShowTootip: false
  }),
  methods: {}
};
</script>
